import { jsx as _jsx } from "react/jsx-runtime";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useAddHomeVideoReviewContext, { initialContext as initialAddHomeVideoReviewContext } from "contexts/AddHomeVideoReview";
import useAddNewsContext, { initialContext as initialAddNewsContext } from "contexts/AddNews";
import useCreateNewsCriticsContext, { initialContext as initialCreateNewsCriticsContext } from "contexts/CreateNewsCritics";
import useCreateReviewsContext, { initialContext as initialCreateReviewsContext } from "contexts/CreateReviews";
import useNewsCriticsContext, { initialContext as initialNewsCriticsContext } from "contexts/NewsCritics";
import usePreviewsContext, { initialContext as initialPreviewsContext } from "contexts/Previews";
import usePreviewsNewsCriticsContext, { initialContext as initialPreviewsNewsCriticsContext } from "contexts/PreviewsNewsCritics";
import useReviewsContext, { initialContext as initialReviewsContext } from "contexts/Reviews";
import useUserContext, { initialContext as initialUserContext } from "contexts/User";
import { createContext } from "react";
const initialContext = {
    addHomeVideoReview: initialAddHomeVideoReviewContext,
    addNews: initialAddNewsContext,
    createNewsCritics: initialCreateNewsCriticsContext,
    createReviews: initialCreateReviewsContext,
    newsCritics: initialNewsCriticsContext,
    previews: initialPreviewsContext,
    previewsNewsCritics: initialPreviewsNewsCriticsContext,
    reviews: initialReviewsContext,
    user: initialUserContext
};
const usePrepareComponent = ({ children }) => {
    const addHomeVideoReviewContext = useAddHomeVideoReviewContext();
    const addNewsContext = useAddNewsContext();
    const previewsContext = usePreviewsContext();
    const previewsNewsCriticsContext = usePreviewsNewsCriticsContext();
    const reviewsContext = useReviewsContext();
    const newsCriticsContext = useNewsCriticsContext();
    const createNewsCriticsContext = useCreateNewsCriticsContext({
        avNirvana: newsCriticsContext.state.avNirvana,
        bluRay: newsCriticsContext.state.bluRay,
        hidefDigest: newsCriticsContext.state.hidefDigest,
        news: newsCriticsContext.state.news,
        singleSource: newsCriticsContext.state.singleSource,
        whySoBlu: newsCriticsContext.state.whySoBlu
    });
    const createReviewsContext = useCreateReviewsContext({
        avForums: reviewsContext.state.avForums,
        avNirvana: reviewsContext.state.avNirvana,
        avsForum: reviewsContext.state.avsForum,
        bluRay: reviewsContext.state.bluRay,
        bluRayAuthority: reviewsContext.state.bluRayAuthority,
        digitalBits: reviewsContext.state.digitalBits,
        doBlu: reviewsContext.state.doBlu,
        hidefDigest: reviewsContext.state.hidefDigest,
        highDefDiscNews: reviewsContext.state.highDefDiscNews,
        homeTheaterForum: reviewsContext.state.homeTheaterForum,
        homeVideoReview: reviewsContext.state.homeVideoReview,
        theaterByte: reviewsContext.state.theaterByte,
        whySoBlu: reviewsContext.state.whySoBlu
    });
    const userContext = useUserContext();
    return {
        addHomeVideoReview: addHomeVideoReviewContext,
        addNews: addNewsContext,
        children,
        createNewsCritics: createNewsCriticsContext,
        createReviews: createReviewsContext,
        newsCritics: newsCriticsContext,
        previews: previewsContext,
        previewsNewsCritics: previewsNewsCriticsContext,
        reviews: reviewsContext,
        user: userContext
    };
};
const MightyTool = createContext(initialContext);
export const AddHomeVideoReviewContext = createContext(initialAddHomeVideoReviewContext);
export const AddNewsContext = createContext(initialAddNewsContext);
export const CreateNewsCriticsContext = createContext(initialCreateNewsCriticsContext);
export const CreateReviewsContext = createContext(initialCreateReviewsContext);
export const NewsCriticsContext = createContext(initialNewsCriticsContext);
export const PreviewsContext = createContext(initialPreviewsContext);
export const PreviewsNewsCriticsContext = createContext(initialPreviewsNewsCriticsContext);
export const ReviewsContext = createContext(initialReviewsContext);
export const UserContext = createContext(initialUserContext);
export const MightyToolProvider = prepareComponent(usePrepareComponent)(({ children, ...props }) => (_jsx(AddHomeVideoReviewContext.Provider, { value: props.addHomeVideoReview, children: _jsx(AddNewsContext.Provider, { value: props.addNews, children: _jsx(CreateNewsCriticsContext.Provider, { value: props.createNewsCritics, children: _jsx(CreateReviewsContext.Provider, { value: props.createReviews, children: _jsx(NewsCriticsContext.Provider, { value: props.newsCritics, children: _jsx(PreviewsContext.Provider, { value: props.previews, children: _jsx(PreviewsNewsCriticsContext.Provider, { value: props.previewsNewsCritics, children: _jsx(ReviewsContext.Provider, { value: props.reviews, children: _jsx(UserContext.Provider, { value: props.user, children: _jsx(MightyTool.Provider, { value: props, children: children }) }) }) }) }) }) }) }) }) })));
export default MightyTool;
